"use strict";

import axios from "axios";
import firebase from "firebase";
// Full config:  https://github.com/axios/axios#request-config
axios.defaults.baseURL = process.env.VUE_APP_API_BASE
axios.defaults.headers.common['Authorization'] = `Bearer: ${localStorage.getItem('gravyauth')}`;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL:  process.env.VUE_APP_API_BASE
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const gravyAxios = axios.create(config);

gravyAxios.interceptors.request.use(
  async function (config) {
    // Do something before request is sent
    const user = firebase.auth().currentUser
    if (user) {
      let result = await user.getIdToken(false)
      axios.defaults.headers.common['Authorization'] = `Bearer: ${result}`;
    }
    // let result = await user.getIdToken(true)
    // console.log(result)
    return config;
  },
  function(error) {
    // Do something with request error
    //   store.dispatch('createAlert', {
    //       type: 'danger',
    //       message: error
    //   })
    // return Promise.reject(error);
  }
);

// Add a response interceptor
// gravyAxios.interceptors.response.use(
//   function(response) {
//     // Do something with response data
//     return response;
//   },
//   function(error) {
//     return error;
//     // Do something with response error
//     // return Promise.reject(error);
//   }
// );
// window.axios = gravyAxios(config)
// Plugin.install = function(Vue, options) {
//   Vue.axios = _axios;
//   window.axios = _axios;
//   Object.defineProperties(Vue.prototype, {
//     axios: {
//       get() {
//         return _axios;
//       }
//     },
//     $axios: {
//       get() {
//         return _axios;
//       }
//     },
//   });
// };


export default gravyAxios;
